import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class MenuService {

    activePanel;
    openElement = '';

    constructor() {
    }

    openMenu(direction) {
        const panel = document.getElementById('panel-' + direction);
        const panelOverlay = document.getElementById('panel-overlay');

        panel.classList.add('active');
        panelOverlay.style.display = 'block';
        panelOverlay.classList.add('active');
        document.body.classList.add('with-panel-' + direction + '-reveal');

        this.activePanel = panel;
        this.openElement = direction;
    }

    hideMenu() {
        const panel = document.getElementById('panel-' + this.openElement);
        panel.style.display = '';
        panel.classList.remove('active');

        const panelOverlay = document.getElementById('panel-overlay');
        panelOverlay.style.display = '';
        panelOverlay.classList.remove('active');
        document.body.classList.add('panel-closing');
        document.body.classList.remove('with-panel-' + this.openElement + '-reveal');

        this.activePanel = panelOverlay;
    }

    swipeHandler(direction) {
        switch (this.openElement) {
            case 'left':
            case 'right':
                this.hideMenu();
                this.openElement = '';
                break;
            case '':
                this.openElement = direction;
                this.openMenu(direction);
                break;
        }
    }
}
